import isMenuHidden from './isMenuHidden';

export default function isOutputPanelHidden() {
    return isMenuHidden(); // TODO: allow toggling "Compile" button separately from editor menu
}
